// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__VbYVn","list":"PatternAutocomplete_list__24kKj"};